import { render, staticRenderFns } from "./ClearSearch.vue?vue&type=template&id=07e012f3&scoped=true&"
import script from "./ClearSearch.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./ClearSearch.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./ClearSearch.vue?vue&type=style&index=0&id=07e012f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e012f3",
  null
  
)

export default component.exports